// extracted by mini-css-extract-plugin
export default {"CheckoutSummary":"CheckoutSummary_CheckoutSummary__29VOT"};